/**
 * Generate the external id of a task service entity. This is done by combining the contextScenarioId and externalObjectId
 * @param contextScenarioId Identifier of the external scenario
 * @param externalObjectId Identifier of the entity within the external scenario
 * @returns External id of the entity
 */ export function generateEntityExternalId(contextScenarioId, externalObjectId) {
    return `S-${contextScenarioId}-I-${externalObjectId}`;
}
